import React from 'react';
import { useSelector } from 'react-redux';
import { A } from 'components/Typography';
import InputErrorMessage from 'products/nomad_insurance/components/InputErrorMessage';

const ErrorMessage = () => {
  const { data: planholder } = useSelector((state) => state.app.profile);

  if (planholder?.homeCountry === 'US') {
    return (
      <span>
        Because your home country is USA, US territories US Virgin Islands and Puerto Rico
        are also considered to be your home country, and can not be your travel
        destination. SafetyWing Nomad Insurance covers medical emergencies during visits
        home to the US of 15 days or shorter. Read more about this{' '}
        <A
          target="_blank"
          rel="noopener noreferrer"
          href="/nomad-insurance/faq?searchStr=Is%20any%20coverage%20provided%20while%20i%20am%20in%20my%20home%20country"
        >
          here
        </A>
        .
      </span>
    );
  }

  return (
    <span>
      We can cover you for brief visits up to 30 days in your home country for every 90
      days you spend abroad. Read more about that{' '}
      <A
        target="_blank"
        rel="noopener noreferrer"
        href="/nomad-insurance/faq?searchStr=Is%20any%20coverage%20provided%20while%20i%20am%20in%20my%20home%20country"
      >
        here
      </A>
      .
    </span>
  );
};

const HomeCountryWarning = () => {
  return <InputErrorMessage errorMessage={<ErrorMessage />} />;
};

export default HomeCountryWarning;
